"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
var supportedFormats = [{
  format: 'DD-MM-YYYY',
  regexp: /^[0-9]{2}-[0-9]{2}-[0-9]{4}$/
}, {
  format: 'DD/MM/YYYY',
  regexp: /^[0-9]{2}\/[0-9]{2}\/[0-9]{4}$/
}, {
  format: 'YYYY-MM-DD',
  regexp: /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/
}, {
  format: 'YYYY/MM/DD',
  regexp: /^[0-9]{4}\/[0-9]{2}\/[0-9]{2}$/
}];
ngModule.factory("pasteUtils", function ($dateFormat) {
  return {
    /**
     * Returns a column from given [rowIdx][colIdx] nested-array table.
     */
    getColumn: function getColumn(table, columnIdx) {
      var column = [];
      _.each(table, function (row, rowIdx) {
        column[rowIdx] = table[rowIdx][columnIdx];
      });
      return column;
    },
    parseExcelDate: function parseExcelDate(cellDate) {
      var format = _.find(supportedFormats, function (format) {
        return format.regexp.test(cellDate);
      });
      if (format == null) {
        return null;
      }
      return moment(cellDate, format.format).toDate();
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/utils/pasteUtils.js
// module id = 2761
// module chunks = 13